import Multiselect from 'multiselect-react-dropdown';
import React, { useEffect, useState } from 'react';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import FilterButtons from '../../Common/FilterButtons';

import qs from 'query-string';
import { useHistory } from 'react-router-dom';

import * as moment from 'moment';
import BuxService from '../../../Service/BuxService';
import Dropdown from '../../ui/Dropdown';
import { hot } from 'react-hot-loader';

const options = [];

const TRANSACTION_SEQUENCE_TAB = 3;

export default hot(module)(function ViewFilter({
	dateRef,
	handleDateEvent,
	fromDate,
	toDate,
	onSearch,
	onResetFilter,
	setType
}) {
	const history = useHistory();

	const [loading, setLoading] = useState(false);
	const [state, setState] = useState({
		_channel: [],
		_type: 'ALL',
		_status: 'ALL',
		_fromDate: null,
		_toDate: null
		// _fromDate: fromDate,
		// _toDate: toDate
	});

	const [senderReceiverDisabled, setSenderReceiverDisabled] = useState(true);

	const handleChange = (name, e) => {
		if (name === '_type') {
			const isCashOutOrTopUp =
				e.target.value === 'cash-out' || e.target.value === 'top-up' || e.target.value === 'ALL';
			setSenderReceiverDisabled(isCashOutOrTopUp);
			if (isCashOutOrTopUp) {
				setState({
					...state,
					[name]: e.target.value,
					_sender: '',
					_receiver: '',
					_fromDate: fromDate ?? state._fromDate,
					_toDate: toDate ?? state._toDate
				});
			} else {
				setState({
					...state,
					[name]: e.target.value,
					_fromDate: fromDate ?? state._fromDate,
					_toDate: toDate ?? state._toDate
				});
			}
		} else {
			setState({
				...state,
				[name]: e.target.value,
				_fromDate: fromDate ?? state._fromDate,
				_toDate: toDate ?? state._toDate
			});
		}
	};

	const handleOnSelect = selectedList => {
		const channelName = selectedList.map(i => i.name);
		const newList = [...channelName];
		state._channel.push(newList[newList.length - 1]);
		setState({ ...state });
	};

	const handleOnRemove = selectedList => {
		state._channel.pop(selectedList);
		setState({ ...state });
	};

	useEffect(() => {
		setState({
			...state,
			_fromDate: fromDate,
			_toDate: toDate
		});
	}, [fromDate, toDate]);

	const handleSearch = e => {
		e.preventDefault();
		if (fromDate && toDate) setState({ ...state, _fromDate: fromDate, _toDate: toDate });
		const { _channel, _type, _status, _fromDate, _toDate } = state;

		const transformedChannel = state._channel ? state._channel.map(item => item + '>>') : [];

		const formData = new FormData(e.target);
		const params = {
			channel: transformedChannel,
			type: formData.get('type'),
			sender: formData.get('sender'),
			receiver: formData.get('receiver'),
			status: formData.get('status'),
			fromDate: _fromDate,
			toDate: _toDate
		};

		// Update the query parameters in the URL
		const queryParams = new URLSearchParams(window.location.search);

		// Iterate over the params object and set the query parameters dynamically
		Object.entries(params).forEach(([key, value]) => {
			if (value) {
				queryParams.set(key, value);
			} else {
				// Delete the query parameter if the value is null
				queryParams.delete(key);
			}
		});

		// Replace the current URL without reloading the page
		window.history.replaceState({}, '', `${window.location.pathname}?${queryParams}`);

		// End of Changing URL

		if (
			// _channel.length > 0 &&
			_type &&
			// _sender.trim() &&
			// _receiver.trim() &&
			_status &&
			_fromDate &&
			_toDate
		) {
			const queryItem = qs.parse(window.location.search);
			queryItem.channel = _channel ?? '';
			queryItem.type = params.type;
			queryItem.sender = params.sender || '';
			queryItem.receiver = params.receiver || '';
			queryItem.status = params.status;
			if (_fromDate) {
				queryItem.fromDate = _fromDate;
			}
			if (_toDate) {
				queryItem.toDate = _toDate;
			}
			if (Number(queryItem.tab) === TRANSACTION_SEQUENCE_TAB) {
				history.push({
					search: qs.stringify(queryItem)
				});
			}

			onSearch();
			setType(_type);
		}
	};

	const resetFilter = () => {
		const fromDate = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
		const toDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');

		if (dateRef.current) {
			dateRef.current.setStartDate(moment(fromDate).toDate());
			dateRef.current.setEndDate(moment(toDate).toDate());
		}

		setState({
			_channel: [],
			_type: 'ALL',

			_status: 'ALL',
			_fromDate: fromDate,
			_toDate: toDate
		});
		dateRef.current.setStartDate(moment(fromDate).toDate());
		dateRef.current.setEndDate(moment(toDate).toDate());
	};

	const setDefaultFilter = () => {
		const queryItem = qs.parse(window.location.search);
		const fromDate = !queryItem.fromDate
			? moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
			: moment(queryItem.fromDate).format('YYYY-MM-DD');

		const toDate = !queryItem.toDate
			? moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
			: moment(queryItem.toDate).format('YYYY-MM-DD');
		if (dateRef.current) {
			dateRef.current.setStartDate(moment(fromDate).toDate());
			dateRef.current.setEndDate(moment(toDate).toDate());
		}

		setState({
			_channel: queryItem.channel
				? queryItem.channel
						.split('>>')
						.filter(str => str.trim() !== '')
						.map(str => (str.startsWith(',') ? str.slice(1) : str))
				: [],
			_type: queryItem.type || 'ALL',

			_status: queryItem.status || 'ALL',
			_fromDate: queryItem.formDate ? queryItem.formDate : fromDate,
			_toDate: queryItem.toDate ? queryItem.toDate : toDate
		});
	};

	const handleSearchMulti = e => {
		options.find(m => m.toString().toLowerCase() === e.target?.name.toString().toLowerCase());
	};

	useEffect(() => {
		setDefaultFilter();
		setLoading(true);
		BuxService.getBanks()
			.then(res => {
				const instapay_banks = res['Instapay Banks']?.map((i, index) => ({
					name: i,
					key: index
				}));
				const pesonet_banks = res['PesoNet Banks']?.map((p, index) => ({
					name: p,
					key: index
				}));

				options.push(...instapay_banks, ...pesonet_banks);
				setLoading(false);
			})
			.catch(error => {
				setLoading(false);
				console.log(error.message);
			});
	}, []);

	function sortOptions(a, b) {
		if (a.name < b.name) {
			return -1;
		}
		if (a.name > b.name) {
			return 1;
		}
		return 0;
	}

	const unique = options.filter((obj, index) => {
		return index === options.findIndex(o => obj.name === o.name);
	});

	return (
		<>
			<form className="col-12" onSubmit={handleSearch}>
				<div style={{ display: 'flex', flexDirection: 'row' }}>
					<div className="col-3">
						<label htmlFor="date">From - To (Date)</label>
						<DateRangePicker onEvent={handleDateEvent} ref={dateRef}>
							<input className="form-control bold-important" type="text" />
						</DateRangePicker>
					</div>
					<div className="col-3">
						<label htmlFor="Type">Type</label>
						<select
							className="form-control"
							name="type"
							onChange={e => handleChange('_type', e)}
							type="select"
							value={state._type}>
							<option value="ALL">ALL</option>
							<option value="top-up">Top-up</option>
							<option value="incoming fund">Loan Fund Transfer</option>
							<option value="outgoing fund">Installment Transactions</option>
							<option value="cash-out">Cash out</option>
						</select>
					</div>
					<div className="col-3">
						<label htmlFor="from">From</label>
						<input
							className="form-control"
							name="sender"
							disabled={senderReceiverDisabled}
							placeholder="Sender Name"
							type="text"
						/>
					</div>
					<div className="col-3">
						<label htmlFor="from">To</label>
						<input
							className="form-control"
							disabled={senderReceiverDisabled}
							name="receiver"
							placeholder="Receiver Name"
							type="text"
						/>
					</div>
				</div>

				<div className="view-bottom-filter">
					<div className="col-4">
						<Dropdown
							name="status"
							filterStatus={state._type}
							onChange={e => handleChange('_status', e)}
							title="Status"
							value={state._status}
						/>
					</div>
					<div className="col-8">
						<label htmlFor="channels">Channel</label>

						<Multiselect
							className="multi-select"
							displayValue="name"
							loading={loading || options.length === 0}
							onKeyPressFn={function noRefCheck() {}}
							onRemove={handleOnRemove}
							onSearch={handleSearchMulti}
							onSelect={handleOnSelect}
							options={unique.sort(sortOptions)}
							selectedValues={
								options.length !== 0
									? Array.isArray(state._channel)
										? state._channel.map(item => options.find(option => option.name === item))
										: state._channel
										? state._channel
												.split(',')
												.map(item => options.find(option => option.name === item))
										: []
									: []
							}
							selectionLimit={4}
						/>
					</div>
				</div>

				<div className="view-bottom-filter-btn">
					<FilterButtons type="submit" resetFilter={resetFilter} />
				</div>
			</form>
		</>
	);
});
